import { GAMING_CONFIG } from "../constants/gaming";
import { urlB64ToUint8Array } from "./systems";

export enum NotificationPermission {
  Default = "default",
  Denied = "denied",
  Granted = "granted",
}

export class PushNotification {
  static subscribe = async () => {
    try {
      const permission = await window.Notification.requestPermission();
      if (permission === NotificationPermission.Granted) {
        const registration = await navigator.serviceWorker.getRegistration();
        let sub = await registration?.pushManager.getSubscription();
        if (!sub) {
          const applicationServerKey = urlB64ToUint8Array(
            GAMING_CONFIG?.pushNotification?.key || "",
          ) as BufferSource | string | null;
          sub = await registration?.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey,
          });
        }
        return JSON.stringify(sub);
      } else {
        throw new Error("Please enable push notification before");
      }
    } catch (e) {
      console.error(e);
      return null;
    }
  };

  static unsubscribe = async () => {
    try {
      const registration = await navigator.serviceWorker.getRegistration();
      const sub = await registration?.pushManager.getSubscription();
      if (sub) {
        await sub.unsubscribe();
      }
    } catch (e) {
      console.error(e);
    }
    return "null";
  };
}
